export default __webpack_public_path__ + "static/media/7.ca3e004e.jpg";